const onlineCheck = async () => {
  try {
    const response = await fetch("https://api.evos.app/");
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    return false;
  }
};

export default onlineCheck;